module.exports = __webpack_public_path__ + "img/resilience.051464e9.jpg";